import React from 'react';
import { useTheme } from '../styles/theme-provider';
import { cn } from '../utils/cn';

interface KeycapLogoProps {
  className?: string;
}

export const KeycapLogo: React.FC<KeycapLogoProps> = ({ className }) => {
  const { resolvedTheme } = useTheme();

  return (
    <img
      src={resolvedTheme === 'dark' ? 'keycap-dark.png' : 'keycap-light.png'}
      alt="CTRL ENTER Logo"
      className={cn(
        'inline-block max-w-full h-auto',
        // Preserve original aspect ratio (191:100)
        'w-[191px] h-[100px]',
        className
      )}
      style={{
        // Fallback for older browsers - preserve aspect ratio
        width: '191px',
        height: '100px',
        maxWidth: '100%',
      }}
    />
  );
};

KeycapLogo.displayName = 'KeycapLogo';
